import produce from 'immer';
import { Reducer } from 'redux';
import {
  IFeatureFlagState,
  IUserContext,
  FeatureFlagsType,
} from '../../common/interfaces/featureFlags';

interface ISetFeatureFlagsAction {
  type: 'featureFlags/setFeatureFlags';
  payload: {
    flags: FeatureFlagsType;
    userContext: IUserContext;
  };
}

interface IUpdateFeatureFlagAction {
  type: 'featureFlags/updateFeatureFlag';
  payload: {
    flagName: string;
    value: boolean;
  };
}

interface ISetUserContextAction {
  type: 'featureFlags/setUserContext';
  payload: IUserContext;
}

export const setFeatureFlags = (
  flags: FeatureFlagsType,
  userContext: IUserContext
): ISetFeatureFlagsAction => ({
  type: 'featureFlags/setFeatureFlags',
  payload: { flags, userContext },
});

type FeatureFlagsAction =
  | ISetFeatureFlagsAction
  | IUpdateFeatureFlagAction
  | ISetUserContextAction;

const defaultValue: IFeatureFlagState = {
  flags: {},
  userContext: null,
};

export const featureFlagsReducer: Reducer<
  IFeatureFlagState,
  FeatureFlagsAction
> = produce((state: IFeatureFlagState, action: FeatureFlagsAction) => {
  switch (action.type) {
    case 'featureFlags/setFeatureFlags':
      state.flags = action.payload.flags;
      state.userContext = action.payload.userContext;
      break;
    case 'featureFlags/updateFeatureFlag':
      state.flags[action.payload.flagName] = action.payload.value;
      break;
    case 'featureFlags/setUserContext':
      state.userContext = action.payload;
      break;
  }
}, defaultValue);

export interface IRootState {
  featureFlags: IFeatureFlagState;
}

export const selectFeatureFlag = (
  state: IRootState,
  flagName: string
): boolean | undefined => {
  return state.featureFlags.flags[flagName];
};

export const selectUserContext = (state: IRootState): IUserContext | null => {
  return state.featureFlags.userContext;
};

export const featureFlagsSelector = (state: IRootState) =>
  state.featureFlags.flags;
export const userContextSelector = (state: IRootState) =>
  state.featureFlags.userContext;
